var Donate = function(options){
    this.settings = $.extend({}, this.defaults, options);
    this.init();
};

Donate.prototype = {

    // shorthand for using prototype
    constructor : Donate,

    // default options
    defaults : {
    },

    // GiftAssist
    feeCoverage : false,
    feeCoverageAmount : 0.00,

    processing : false,

    // stores the donation system search
    donationRecipientSearch : null,

    selectedAmountId: "",

    init : function(){
        var _this = this,
            $form = $('.js-donation-form');

        // set the form
        _this.form = $('#form-id').val();

        // reset form value
        _this.updateCustomFields(0.00);

        // can the donor cover fees?
        _this.feeCoverage = ( QGIV.Form.feeCoverage.type > 0 ) ? true : false;

        // bind donation form validation
        $form.validate();

        // initialize the Matching Gifts plugin
        if ( QGIV.MatchingGifts ) {
            QGIV.MatchingGifts.init();
        }

        // bind AutoNumeric for other donation amount
        if ( $('#other_donation_amount').length ) AutoNumericNumber('#other_donation_amount');

        // bind AutoNumeric for matching gift amount
        if ( $( '.js-matching-gift-amount' ).length ) AutoNumericNumber( '.js-matching-gift-amount' );

        // bind country selector
        $form.find('.has-country-selector').countrySelector();

        // bind credit card validator
        UI.paymentValidation();

        // init select boxes
        UI.renderCustomSelect();
        // init tags-input plugin
        if ( $.fn.tagsInput ) {
            $('#dedication-recipient').tagsInput({
                onChange: function($el, tag) {
                    $(this).trigger('blur')
                },
                defaultText: 'email@example.com',
                height: 'auto',
                width: '100%'
            });
            $('#dedication-recipient_tag').prop('autocomplete', 'off');
        }

        // Recurring Frequency Toggles
        $( '.js-recurring-frequency-option' ).on( 'click', function( e ) {
            var $this = $(this);
            const recurringFrequency = $this.find("input[value]").val();

            // Make sure option is checked
            if ( !$( 'input:checked', $this ).length > 0 ) {
                $( '.js-recurring-frequency-option input:checked' ).removeAttr( 'checked' );
                $this.find( 'input' ).prop( 'checked', true );
            }
            // Toggle the frequency date selection and donation matching option
            if ( $this.find( 'input[value]' ).val() !== 'n' ) {
                $('.js-donation-frequency-range').removeClass('hide-content');
                // If matching option is selected, de-select it.
                if ( $( '#is-eligible-for-match:checked' ).length > 0 ) {
                    $( '#is-eligible-for-match:checked' ).trigger( 'click' );
                }
            } else {
                $('.js-donation-frequency-range').addClass('hide-content');
            }
            // Setup active option
            $this.closest('.js-recurring-frequency').find('.js-recurring-frequency-option').removeClass('is-active ui-primary-color ui-text-primary-color');
            $this.closest('.js-recurring-frequency-option').addClass('is-active ui-primary-color ui-text-primary-color');
            // Re-authenticate paypal
            if ( typeof QGIV.PayPal !== 'undefined' ) {
                QGIV.PayPal.resetAuthentication();
            }

            // load the correct PayPal SDK buttons
            if (QGIV.PayPalSdk?.isEnabled) {
                if (recurringFrequency === "n") {
                    QGIV.PayPalSdk.initPayPalOneTime();
                } else {
                    QGIV.PayPalSdk.initPayPalRecurring();
                }
            }
        });

        // trigger click on page load if selected
        $('.js-recurring-frequency-option input:checked').closest('.js-recurring-frequency-option').trigger('click');

        // init datepicker
        $('.datepicker').Zebra_DatePicker({
            format: 'm/d/Y',
            first_day_of_week: 0,
            direction: [true, false],
            show_icon : false,
            show_select_today : false,
            show_clear_date : false,
            readonly_element : false,
            onSelect : function(formattedDate, standardDate, jsDate, el){
                el.trigger('blur');
            }
        });
        $('.js-recurring-start-date').Zebra_DatePicker({
            pair: $('.js-recurring-end-date'),
            format: 'm/d/Y',
            direction: [true, false],
            show_icon : false,
            show_select_today : false,
            show_clear_date : false,
            readonly_element : false,
            onSelect : function(formattedDate, standardDate, jsDate, el){
                el.trigger('blur');
            }
        });

        $('.js-recurring-end-date').Zebra_DatePicker({
            format: 'm/d/Y',
            direction: true,
            show_icon : false,
            show_select_today : false,
            show_clear_date : false,
            readonly_element : false,
            onSelect : function(formattedDate, standardDate, jsDate, el){
                el.trigger('blur');
            }
        });

        // loading modal
        if ( $('#loading-modal').length ){
            $('#loading-modal').modal({
                disableTrigger : true,
                bgClose : false
            });
        }

        // dedication recipient preview modal
        if ( $('#notification-preview-modal').length ){
            $('.js-preview-email').modal({
                width : 'width-50',
                beforeShowModal : function() {
                    var dedContent = $('#dedication-notification-template').val(),
                        firstName = ($('#first-name').val() ? $('#first-name').val() : ''),
                        lastName = ($('#last-name').val() ? $('#last-name').val() : ''),
                        dedicationText = ($('#donation-dedication').val().length ? $('#donation-dedication option:selected').text() : ''),
                        dedicationName = ($('#dedication_text').val().length ? $('#dedication_text').val() : ''),
                        dedicationMessage = ($('#dedication-message').val().length ? $('#dedication-message').val() : ''),
                        postString = '';

                    if ($('#donation-dedication').val().length) {
                        dedicationText = $('#donation-dedication option:selected').text();
                    }

                    if (firstName) postString += '&donation[firstName]=' + firstName;
                    if (lastName) postString += '&donation[lastName]=' + lastName;
                    if (dedicationText) postString += '&donation[dedicationText]=' + dedicationText;
                    if (dedicationName) postString += '&donation[dedicationName]=' + dedicationName;
                    if (dedicationMessage) postString += '&donation[dedicationMessage]=' + dedicationMessage;

                    var form = $('input[name="form"]').val(),
                        requestUrl = url('template_preview', [form,QGIV.MailEvent.DONATION_DEDICATION]);

                    $.fn.qpost({
                        url : requestUrl,
                        csrf : false,
                        data : postString,
                        success : function(data) {
                            if (data.success && data.content) {
                                $('.dedication-notification-preview').empty().html(data.content);
                            } else {
                                Message.target = '#donation-form';
                                Message.post(data.errors, "error");
                            }
                        },
                        failure : function() {
                            Message.target = '#donation-form';
                            Message.post("Whoops! It appears something went wrong. Please try again.", "error");
                        },
                    });
                }
            });
        }

        // loading modal
        if ( $('#donation-recipient-modal').length ){
            // move the modal out of the donation form
            // becuase hitting enter in IE tries to submit
            $('#donation-recipient-modal').appendTo('body');

            // after the move, initialize
            $('#donation-recipient-modal').modal({
                disableTrigger : true,
                bgClose : true,
                width : $('#donation-recipient-modal').attr('data-width'),
                afterCloseModal : function() {
                    _this.resetEntitySearchModal();
                }
            });

            _this.donationRecipientModal = $('#donation-recipient-modal').data('qg_modal');
        }

        // toggle label states
        $('[name="donation_amount"]').on('change', function () {
            var $donationButton = $(this).closest('.donation-button'),
                amount = '0.00';

            $('.donation-button').removeClass('active');
            $('.donation-button .option-title').addClass('ui-text-primary-color').removeClass('text-white');
            $('[name="donation_amount"]:checked').closest('.donation-button').addClass('active');
            _this.selectedAmountId = $(this).data('id') ?? "";

            if ( $donationButton.hasClass('ui-button') ) {
                $('.donation-button')
                    .addClass('ui-text-primary-color')
                    .removeClass('ui-primary-color')
                    .addClass('secondary');

                $('[name="donation_amount"]:checked').closest('.donation-button')
                        .addClass('ui-primary-color')
                        .removeClass('ui-text-primary-color')
                        .removeClass('secondary');

            } else if ( $donationButton.hasClass('option-label') ) {

                $('.donation-button')
                    .removeClass('text-white ui-primary-color');

                $('[name="donation_amount"]:checked').closest('.donation-button')
                    .addClass('text-white ui-primary-color');

                $('.donation-button.active .option-title')
                    .addClass('text-white')
                    .removeClass('ui-text-primary-color');
            }

            if ($donationButton.attr('id') === 'donate_other_trigger' && $('[name="other_donation_amount"]').val() > 0) {
                amount = $('[name="other_donation_amount"]').val();
            } else {
                // if this is not a custom amount, make sure the custom amount is cleared out.
                $('[name="other_donation_amount"]').val('').trigger('change').trigger('blur');

                amount = $(this).val();
            }

            // check if we need to update custom fields based on amount
            _this.updateCustomFields(amount);

            _this.updateTotal();
        });

        // we need to use a span for the other amount button, but still need to trigger the radio button to be checked
        $('#donate_other_trigger').on('click', function () {
            $(this).find('#donate_other').prop('checked', true).trigger('change');
            $(this).find('#other_donation_amount').focus();
        });

        // when typing a different amount
        $('#other_donation_amount').on('keyup change', function () {
            var val = $(this).val(),
                valFormatted = val.replace(/,/g, ''),
                valConverted = _this.convertToNumber(val);

            // update the hidden radio amount
            $(this).closest('.donation-button').find('[name="donation_amount"]').val(valFormatted);

            // update custom fields for 'required if $ > x'
            valConverted > 0 ? _this.updateCustomFields(valConverted) : null;

            _this.updateTotal();
        });

        // classifications / restrictions / dedications
        $(".js-restriction-select")
            .on("change", function () {
                var $changed = $(this);
                var $selected = $changed.find("option:selected");
                var description = $selected.attr("data-value");
                var $target = $selected.attr("data-content-toggle");
                var restrictionId = $selected.attr("data-restriction-id");

                // copy the restriction id for now as it's not fully integrated in all places
                $(".js-restriction-id-input").val(restrictionId);

                $($target).find("p").text(description);
            })
            .trigger("change");

        // apply total update when adding fee
        $('#fee-coverage').on('change', function(){
            _this.updateTotal();
        });

        // PayPal authentication
        if ( typeof QGIV.PayPal !== 'undefined' ) {
            QGIV.PayPal.onBeforeOpen = function($button){
                var $selectedAmount = $('.js-donation-amount-option:checked'),
                    donationAmount = $selectedAmount.val(),
                    $frequency = $('.js-recurring-frequency-option').find( 'input:checked' ),
                    frequency = $frequency.val();

                // make sure we have a valid amount
                if ( $selectedAmount.length && _this.convertToNumber(donationAmount) > 0 ){
                    // grab transaction amount
                    this.path += '&amount=' + donationAmount;
                    this.authorizedAmount = _this.convertToNumber(donationAmount);

                    // Add recurring donation params
                    if ( $frequency.length && frequency !== 'n' ) {
                        this.path += '&recurring=' + frequency;

                        // add start date
                        this.path += '&begin_date=' + $('.js-recurring-start-date').val();

                        // check if we should add end date
                        if ( $('.js-recurring-end-date').length && $('.js-recurring-end-date').val() !== '' ){
                            this.path += '&end_date=' + $('.js-recurring-end-date').val();
                        }
                    }

                    // we've got what we need, make sure the session is validated
                    this.validated = true;

                } else {
                    // un-validate the PayPal session since there are errors
                    this.validated = false;

                    // trigger an error message to select an amount
                    Message.target = '#donation-form';
                    Message.type = 'error';
                    Message.setMessage('Please select an amount.');
                    Message.postMessage();
                }
            };

            QGIV.PayPal.init();
        }

        // Functions for processing transactions via legacy P2P donation with
        // new PayPal API
        if (QGIV.PayPalSdk?.isEnabled && $("#donation-form-container").length) {
            /**
             * @function addTotalToPostString
             * @description Handles converting the postString returned from
             *      submitDonation into an object
             * @param {string} postString Post string returned from calling
             *      submitDonation
             * @returns {jQuery.deferred.promise} Promise used for chaining
             */
            const addTotalToPostString = (postString) => {
                const dfd = $.Deferred();
                const totalString = `&total=${_this.updateTotal()}`;

                QGIV.PayPalSdk.postString = `${postString}${totalString}`;

                dfd.resolve();
                return dfd.promise();
            };

            /**
             * @function getCreateOrderData
             * @description Calls submitDonation, which builds a post string
             *      from form inputs and calls the passed callback,
             *      addTotalToPostString, with the post string as a parameter
             * @returns {jQuery.deferred.promise} Promise used for chaining
             */
            const getCreateOrderData = () =>
                this.submitDonation(addTotalToPostString, {
                    // Flag used to bypass validation logic. If this is not
                    // passed, gatherInputs will throw errors because we're
                    // not passing an `error` handling function.
                    authenticatingPayPal: true,
                });

            QGIV.PayPalSdk.$container = $form.find(
                ".js-authenticate-paypal-container",
            );
            QGIV.PayPalSdk.getCreateOrderData = getCreateOrderData;
        }

        // Apple Pay setup
        if ( typeof QGIV.ApplePay !== 'undefined' ) {
            QGIV.ApplePay.onBeforeOpen = function($button){
                var $selectedAmount = $('.js-donation-amount-option:checked'),
                    donationAmount = $selectedAmount.val(),
                    $frequency = $('.js-recurring-frequency-option input:checked'),
                    frequency = $frequency.val();

                var request = {};

                // storage for line items
                request.lineItems = [];

                // make sure we have a valid amount
                if ( $selectedAmount.length && _this.convertToNumber(donationAmount) > 0 ){
                    var transactionTotal = donationAmount;

                    if ( $frequency.length && frequency !== 'n' ){
                        var lineItem = {
                            'label' : $frequency.attr('data-label') + ' Donation',
                            'amount': transactionTotal
                        };

                        // if start date is after today, set the line item type to "pending"
                        var today = new Date(),
                            recurringStart = new Date($('.js-recurring-start-date').val());

                        if ( recurringStart > today ) {
                            lineItem.type = "pending";
                        }

                        // if there is an end date, display it in the line item
                        if ( $('.js-recurring-end-date').length && $('.js-recurring-end-date').val() !== '' ){
                            lineItem.label += ' ending on ' + $('.js-recurring-end-date').val();
                        }

                        request.lineItems.push(lineItem);
                    } else {
                        request.lineItems.push({
                            'label' : 'One-Time Donation',
                            'amount': transactionTotal
                        });
                    }

                    // GiftAssist line item
                    // if GiftAssist is checked, add it to the total
                    if ( $('.js-fee-coverage-checkbox').is(':checked') ){
                        request.lineItems.push({
                            'label' : 'Fee Coverage',
                            'amount' : _this.feeCoverageAmount
                        });

                        transactionTotal = _this.convertToNumber(donationAmount) + _this.convertToNumber(_this.feeCoverageAmount);
                    }

                    // grab transaction amount
                    request.total = { label : 'Total', amount : transactionTotal };

                    QGIV.PaymentRequest = $.extend({}, QGIV.PaymentRequest, request);

                    // we've got what we need, make sure the session is validated
                    this.validated = true;
                } else {
                    // un-validate the Apple Pay session since there are errors
                    this.validated = false;

                    // trigger an error message to select an amount
                    Message.target = '#donation-form';
                    Message.type = 'error';
                    Message.setMessage('Please select an amount.');
                    Message.postMessage();
                }
            };

            QGIV.ApplePay.onPaymentAuthorized = function(response){
                // analytics tracking for people who use Apple Pay
                QGIV.Analytics.GA.send({
                    hitType : 'event',
                    eventCategory : 'Donation Form',
                    eventAction : 'paid',
                    eventLabel : 'Apple Pay'
                });

                $form.submit();
            };

            QGIV.ApplePay.init();
        }

        // initialize analytics events after initial values have been set
        if (
            QGIV.DonationAnalyticsEvents &&
            QGIV.AnalyticsEvents?.shouldRunAnalyticsEvents()
        ) {
            QGIV.DonationAnalyticsEvents.sendStartAnalyticsEvents();
            QGIV.DonationAnalyticsEvents.setUpClosedAnalyticsEvents();
        }

        // handle form submission
        $form.on('submit', function(e){
            // prevent standard form submission
            e.preventDefault();

            _this.submitDonation();
        });

        $('.js-change-donation-recipient').on('click', function(e) {
            e.preventDefault();

            _this.donationRecipientModal.showModal();
            $('#search-donation-recipients').focus();

            if ( SystemSearch && ! _this.searchReady ) {
                _this.initDonationSearch();
                _this.searchReady = true;
            }

            if ( _this.searchReady ) {
                _this.donationRecipientSearch.triggerSearch();
            }
        });
        _this.updateTotal();
    },


    submitDonation : function(postFunction, settings) {
        var _this = this,
            $form = $('.js-donation-form'),
            defaultSubmitText = $('.js-submit-donation-button').val(),
            loadingModal = $('#loading-modal').data('qg_modal'),
            errors = [];

        // prevent double processing
        if ( _this.processing ) return false;

        if (!settings?.authenticatingPayPal) {
            _this.processing = true;

            // show that the button was clicked
            $(".js-submit-donation-button")
                .prop("disabled", true)
                .val("Processing Donation...");

            // show the loading modal
            if (typeof loadingModal !== 'undefined') loadingModal.showModal();
        }

        var entity = $('input[name="entity"]').val();
        var view = $('input[name="donation_type"]').val();
        var form = $('input[name="form"]').val();
        var formAlias = $('input[name="form_alias"]').val();
        var exclude = [
            'Matching[company_name]',
            'Matching[company_id]',
            'Matching[parent_raw_id]',
            'Matching[contact_address_line1]',
            'Matching[contact_address_line2]',
            'Matching[contact_city]',
            'Matching[contact_state]',
            'Matching[contact_zip]',
            'Matching[contact_phone]',
            'Matching[contact_email]',
            'Matching[donor_found]',
            'Matching[donor_verified]'
        ];

        //ensuring that we still use an id for any events that for some reason do not have an alias
        var urlForm = (formAlias == "") ? form : formAlias;

        var requestUrl = ($('input[name="classification"]').val().length) ? url(view,[urlForm, $('input[name="classification"]').val()]) : url(view, [urlForm, entity]);
        var postString = buildPostString($form, exclude);

        // add paypal tokens to the post string
        if ($('#paypal-token').length > 0) {
            postString += "&Payment[paypal_token]="+encodeURIComponent($('#paypal-token').val());
            postString += "&Payment[payer_id]="+encodeURIComponent($('#paypal-payerID').val());
        }

        // add captcha values if it exists
        if ($('#hobnob-captcha').length) {
            postString += "&g-recaptcha-response="+encodeURIComponent($('#g-recaptcha-response').val());
        }

        // add matching values if they exist
        if ( $('[name="Matching[company_name]"]').length && $( '[name="Matching[company_name]"]').val().length > 0 ) {
            postString += '&Matching[company_name]=' + encodeURIComponent( $( '[name="Matching[company_name]"]').val() );
        } else if ( $('[name="Matching[company_name]"]').length && $('.js-matching-gift-service').val() === '2' ) {
            postString += '&Matching[company_name]=';
        }
        if ( $('[name="Matching[company_id]"]').length && $( '[name="Matching[company_id]"]').val().length > 0 ) {
            postString += '&Matching[company_id]=' + encodeURIComponent( $( '[name="Matching[company_id]"]').val() );
        } else if ( $('[name="Matching[company_id]"]').length && $('.js-matching-gift-service').val() === '2' ) {
            postString += '&Matching[company_id]=';
        }
        if ( $('[name="Matching[parent_raw_id]"]').length && $( '[name="Matching[parent_raw_id]"]').val().length > 0 ) {
            postString += '&Matching[parent_raw_id]=' + encodeURIComponent( $( '[name="Matching[parent_raw_id]"]').val() );
        }
        if ( $('[name="Matching[contact_address_line1]"]').length && $( '[name="Matching[contact_address_line1]"]').val().length > 0 ) {
            postString += '&Matching[contact_address_line1]=' + encodeURIComponent( $( '[name="Matching[contact_address_line1]"]').val() );
        }
        if ( $('[name="Matching[contact_address_line2]"]').length && $( '[name="Matching[contact_address_line2]"]').val().length > 0 ) {
            postString += '&Matching[contact_address_line2]=' + encodeURIComponent( $( '[name="Matching[contact_address_line2]"]').val() );
        }
        if ( $('[name="Matching[contact_city]"]').length && $( '[name="Matching[contact_city]"]').val().length > 0 ) {
            postString += '&Matching[contact_city]=' + encodeURIComponent( $( '[name="Matching[contact_city]"]').val() );
        }
        if ( $('[name="Matching[contact_state]"]').length && $( '[name="Matching[contact_state]"]').val().length > 0 ) {
            postString += '&Matching[contact_state]=' + encodeURIComponent( $( '[name="Matching[contact_state]"]').val() );
        }
        if ( $('[name="Matching[contact_zip]"]').length && $( '[name="Matching[contact_zip]"]').val().length > 0 ) {
            postString += '&Matching[contact_zip]=' + encodeURIComponent( $( '[name="Matching[contact_zip]"]').val() );
        }
        if ( $('[name="Matching[contact_phone]"]').length && $( '[name="Matching[contact_phone]"]').val().length > 0 ) {
            postString += '&Matching[contact_phone]=' + encodeURIComponent( $( '[name="Matching[contact_phone]"]').val() );
        }
        if ( $('[name="Matching[contact_email]"]').length && $( '[name="Matching[contact_email]"]').val().length > 0 ) {
            postString += '&Matching[contact_email]=' + encodeURIComponent( $( '[name="Matching[contact_email]"]').val() );
        }
        if ( $('[name="Matching[donor_found]"]').length && $( '[name="Matching[donor_found]"]').val().length > 0 ) {
            postString += '&Matching[donor_found]=' + encodeURIComponent( $( '[name="Matching[donor_found]"]' ).val() );
        }
        if ( $('[name="Matching[donor_verified]"]').length && $( '[name="Matching[donor_verified]"]').val().length > 0 ) {
            postString += '&Matching[donor_verified]=' + encodeURIComponent( $( '[name="Matching[donor_verified]"]' ).val() );
        }

        // we're using a stored payment type so we need to add some post data and update some validation
        // TODO : consolidate this logic across the system
        if ( $('.js-payment-type-stored:checked').val() == 'stored' ) {
            postString += '&Payment[cardId]=' + $('.js-account-payment-method:checked').val();
            postString += '&Payment[type]=stored';

            // validate the form excluding payment fields
            errors = $form.data('qg_validation').validateForm(false, $('.payment-type-fields input'));
        }
        // this a standard payment, validate normally
        else {
            errors = $form.data('qg_validation').validateForm();
        }

        // posting the shortcode token, if it was found in the url
        var urlParams = ( window.location.pathname ).split( '/' );
        var shortcodeToken = '';
        var isSMS = urlParams.indexOf( 'sms' );
        //checking if SMS key is defined, and if the next index exists
        if ( isSMS !== -1 && urlParams[ isSMS + 1 ] !== void 0 ) {
            shortcodeToken = urlParams[ isSMS + 1 ];
        }
        postString += '&shortcode=' + encodeURIComponent(shortcodeToken);

        if (_this.selectedAmountId) {
            postString += '&donation_amount_id=' + encodeURIComponent(_this.selectedAmountId);
        }

        // donation amount validation
        // the value for donation amount radio inputs are the dollar value of the amount
        // other amount value is dynamically set so we don't need to check for the text input value
        if ( ! parseFloat($('.js-donation-amount-option:checked').val()) ) {
            errors.unshift('Please select an amount');
        }

        // donation recipient validation
        if ($('.js-no-donation-recipient[data-required="true"]').length > 0) {
            if ($('input[name="donation_type"]').val() === 'event_donation') {
                errors.unshift('Please select a donation recipient');
            }
        }

        // prevent post if there are errors
        if ( errors.length ) {
            // display errors
            Message.target = $form;
            Message.post(errors, 'error');

            // reset the processing UI
            $('.js-submit-donation-button').prop('disabled', false).val( defaultSubmitText );
            _this.processing = false;

            // hide the modal
            if ( typeof loadingModal !== 'undefined' ) loadingModal.closeModal();
            return;
        }
        // there aren't any front-end errors, move along to AJAX call

        // if postFunction is passed, call it
        if (typeof postFunction === "function") {
            return postFunction(postString);
        }

        // otherwise use the default qpost function
        $.fn.qpost({
            url : requestUrl,
            csrf : true,
            data : postString,
            success : function(data) {
                if (data.success) {
                    // remove and emit relevant analytics events
                    if (
                        QGIV.DonationAnalyticsEvents &&
                        QGIV.AnalyticsEvents?.shouldRunAnalyticsEvents()
                    ) {
                        QGIV.DonationAnalyticsEvents.sendCompleteAnalyticsEvents(
                            data,
                        );
                        QGIV.DonationAnalyticsEvents.removeClosedAnalyticsEvents();
                    }
                    // redirect to receipt page
                    window.location.href = url('donation_receipt', [urlForm, data.id]) + '?success=1';
                } else {
                    // enable the submit
                    $('.js-submit-donation-button').prop('disabled', false).val( defaultSubmitText );
                    _this.processing = false;

                    // hide the modal
                    if ( typeof loadingModal !== 'undefined' ) loadingModal.closeModal();

                    Message.target = '#donation-form';
                    Message.post(data.errors, "error");
                }
            },
            failure : function() {
                // enable the submit
                $('.js-submit-donation-button').prop('disabled', false).val( defaultSubmitText );
                _this.processing = false;

                // hide the modal
                if ( typeof loadingModal !== 'undefined' ) loadingModal.closeModal();

                Message.target = '#donation-form';
                Message.post("Our system was unable to process your donation. Please try again later.", "error");
            },
        });
    },

    // convert to number
    convertToNumber : function(string){
        var string = string || '';

        if ( typeof string == 'string' ){
            string = string.replace(/\,/g, '');
        }

        string = parseFloat(string);

        return string;
    },

    // add covered fee if it's enabled
    addFeeCoverage : function(amount){
        var _this = this,
            _amount = amount || 0.00;

        if ( _this.feeCoverage ) {
            // calculate the fee based on form settings
            var calculatedFee = QGIV.FeeCoverage.calculateFee(_amount, QGIV.Form.feeCoverage.type, QGIV.Form.feeCoverage.value);

            // set the fee amount in the Form object
            _this.feeCoverageAmount = calculatedFee;

            // update front-end areas where we display the fee amount
            $('.js-covered-fee-calculation').text(this.feeCoverageAmount);
            $('.js-fee-coverage-amount').val(_this.feeCoverageAmount);
        }
    },

    // updates the total in the form actions div
    updateTotal : function () {
        var _this = this,
            donationAmt = $('[name="donation_amount"]:checked').val(),
            $totalAmt = $('.total-amount span'),
            $giftAssist = $('.js-giftassist-option');

        // format the currency
        if ( typeof QGIV !== 'undefined' && typeof QGIV.Form !== 'undefined' ){
            // add additional fees, if applicable
            _this.addFeeCoverage(donationAmt);

            // add the fee to the total
            if ( $('#fee-coverage').is(':checked') ){
                donationAmt = _this.convertToNumber(_this.feeCoverageAmount) + _this.convertToNumber(donationAmt);
            }

            // format the currency
            donationAmt = currencyFormat(donationAmt, QGIV.Form.currency.format);
        }

        // if enabled, update max matching gift amount if enabled
        if ( $('.js-matching-details').length ) {
            var maxAmount = donationAmt;
            var maxAmountFormatted = parseFloat(maxAmount.replace(/,/g, '')).toFixed(2);
            var matchingRatio = $('.js-matching-gift-amount').attr('data-matching-ratio') || 1;
            $('.js-matching-gift-amount').attr('data-max-amount', maxAmountFormatted * matchingRatio);

            if ( $('.js-matching-gift-amount').val() != '' ) {
                $('.js-matching-gift-amount').trigger('blur');
            }
        }

        // check if we need to re-authorize PayPal tokens
        if ( typeof QGIV.PayPal !== 'undefined' ) {
            QGIV.PayPal.validateAuthorizedAmount(donationAmt);
        }

        // There is not a good way to check if the various line items we send to
        // PayPal have changed, so we need to deauthorize every time we
        // recalculate the totals.
        if (QGIV.PayPalSdk?.isEnabled) {
            QGIV.PayPalSdk?.deauthorize();

            // if using PayPal SDK, disable/enable PayPal buttons based on amount
            if (donationAmt === "0.00" || $("html").hasClass("cms-enabled")) {
                QGIV.PayPalSdk?.disableButtons();
            } else {
                QGIV.PayPalSdk?.enableButtons();
            }
        }

        if ( donationAmt !== '0.00' ) {
            $giftAssist.removeClass('hide-content');
            $totalAmt.text(donationAmt);
            if ( QGIV.MatchingGifts ) $('.js-employer-selection-amount').text( '$' + donationAmt );
        } else {
            $giftAssist.addClass('hide-content');
            $totalAmt.text('0.00');
            if ( QGIV.MatchingGifts ) $('.js-employer-selection-amount').html( '$0.00' );
        }

        return donationAmt;
    },

    // check for required custom fields
    updateCustomFields : function(amount){
        $(".custom-fields .field-label")
            .toArray()
            .forEach((element) => {
                const $element = $(element);
                if ($element.attr("data-required-amount")) {
                    if (
                        parseFloat(amount) >
                        parseFloat($element.attr("data-required-amount"))
                    ) {
                        if (!$element.find(".required-label").length > 0) {
                            $element.append(
                                '<span class="field-secondary-label required-label">Required</span>',
                            );
                            $element
                                .closest(".field-container")
                                .find(".form-field, .field-input")
                                .addClass("validateEmpty");
                            $element
                                .closest(".field-container")
                                .find(".ui-select")
                                .addClass("validateSelectEmpty");
                            $element
                                .closest(".field-container")
                                .find(".field-checkbox")
                                .addClass("validateRequiredCheck");
                        }
                    } else {
                        $element.find(".required-label").remove();
                        $element
                            .closest(".field-container")
                            .find(
                                ".form-field, .field-input, .ui-select, .field-checkbox",
                            )
                            .removeClass(
                                "validateEmpty validateSelectEmpty validateRequiredCheck has-error",
                            );
                        $element
                            .closest(".field-container")
                            .find(".field-message")
                            .remove();
                    }
                }
            });
    },

    initDonationSearch : function() {
        var _this = this;

        _this.searchField = '#search-donation-recipients';
        _this.searchResults = '#search-donation-recipients-results';

        _this.searchSettings = {
            form : $('input[name="form"]').val(),
            filters : {
                search_term : $( _this.searchField ).val(),
                search_category : 'donation_entity',
                donation_search : true,
                template: 'donation_recipients_search_results'
            },
            autoSearch : false,
            operation : $('input[name="search_type"]').val(),
            container : '.js-donation-recipient-search',
            searchInput : _this.searchField,
            resultContainer : _this.searchResults,
            request : url('event_search', [$('input[name="form"]').val()]),
            saveSettings : false,
            onSuccess : function( data ){
                var $columns = $(_this.searchResults).find('.grid-unit'),
                    participantLabel = $(_this.searchResults).attr('data-participant-label') + 's',
                    teamLabel = $(_this.searchResults).attr('data-team-label') + 's';

                noResultsCheck( data );

                $('.js-registration-result-divider').text( participantLabel );
                $('.js-team-result-divider').text( teamLabel );

                $('.js-donation-recipient-search').find('.clear-search-button').removeClass('hide-content');

                if ( $columns.length == 1 ) {
                    $columns.removeClass('six-twelfths').addClass('whole');
                }
            }
        }

        var noResultsCheck = function( data ) {
            if ( ! data.entities ) {
                $(_this.searchResults).html('<div class="grid-unit whole text-center"><div class="padding-1x">No Results</div></div>');
            }
        };

        $('#donor-recipient-search-form').on('submit', function(e) {
            e.preventDefault();
        });

        $(_this.searchResults).on('click', '.js-select-donation-recipient', function() {
            var $this = $(this),
                entityId = $this.attr('data-entity-id'),
                entityName = $this.attr('data-entity-name'),
                entityType = $this.attr('data-entity-type'),
                $entityAvatar = $this.find('.mini-avatar'),
                viewName;

            // Populate the message with the new name and avatar
            $('.js-donation-recipient-container')
                .find('.js-entity-name').text( entityName ).end()
                .find('.donation-recipient-avatar').html( $entityAvatar ).end()
                .find('.js-has-donation-recipient').removeClass('hide-content').end()
                .find('.js-no-donation-recipient').addClass('hide-content');

            // Update form data for post
            switch (entityType) {
                case 'registration':
                    viewName = 'account_donation';
                    break;
                case 'team':
                    viewName = 'team_donation';
                    break;
                case 'classification':
                    viewName = 'classification_donation';
                    break;
                default:
                    viewName = 'event_donation';
            }

            // reset our classification
            $('input[name="classification"]').val('');

            // check if we're selecting a classification and populate correctly
            // else, just set the correct entity ID
            if ( entityType == 'classification' ){
                $('input[name="entity"]').val($('#form-id').val());
                $('input[name="classification"]').val(entityId);
            } else {
                $('input[name="entity"]').val( entityId );
            }

            $('input[name="donation_type"]').val( viewName );

            // Close the search modal
            _this.donationRecipientModal.closeModal();
        });

        $('.js-undo-donation-recipient').on('click', function(e) {
            e.preventDefault();

            $('.js-donation-recipient-container')
                .find('.js-has-donation-recipient').addClass('hide-content').end()
                .find('.js-no-donation-recipient').removeClass('hide-content');

            // Update form data for post
            $('input[name="entity"]').val( $('input[name="form"]').val() );
            $('input[name="donation_type"]').val( 'event_donation' );
            $('input[name="classification"]').val('');
        });

        $('.clear-search-button').on('click', function() {
            $(this).addClass('hide-content');

            _this.resetEntitySearchModal();
        });

        //instantiate the search
        _this.donationRecipientSearch = new SystemSearch( _this.searchSettings );
    },

    resetEntitySearchModal : function() {
        var _this = this;

        // Reset the search field and results
        $(_this.searchField).val('').blur();
        setTimeout(function() {
            $(_this.searchResults).find('.grid-unit').remove();
        }, 300);
    },
}

$(document).ready(function(){
    var _donate = new Donate();
});
